/**
 * @desc 新增管理域
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/base/add',
    data,
  });
}

export function mock(
  data: defs.TheNewManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/base/add',
    data,
  });
}
